import React from "react";
import StackingCards from "../../../utils/StackingCards";
import CanvasAnimation1 from "../../../utils/CanvasAnimation1"
import Test from "../../../utils/Test";

const Ecosystem = () => {
  var settings = {
    dots: false, // Disable dots for navigation
    arrows: false, // Disable navigation arrows
    autoplay: true, // Enable autoplay
    infinite: true, // Allow infinite scrolling
    speed: 500, // Transition speed (500ms)
    slidesToShow: 1, // Number of slides to show at a time
    slidesToScroll: 1, // Number of slides to scroll at a time
    autoplaySpeed: 3000, // Set the autoplay speed (default 3000ms = 3 seconds)
  };
  return (
    <div id="ecosystem">

      <div className="news eco mb-0" style={{ background: "none" }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>
                {" "}
                <div className="position-relative">
                  <h1>Ecosystem </h1>
                  <h2 className="bordered-text">Ecosystem </h2>
                </div>
              </h1>
            </div>
            <div className="col-12 col-xl-12 mt-5 mb-5">
              <p className="p mt-0 mt-lg-5 mb-5">
                The ecosystem features a dVPN app accessible on all major platforms and the Nebula Lite, a proprietary hardware device designed for enhanced privacy and security. With plans to integrate additional privacy-focused services, the Cosmic Network is paving the way for the future of decentralized technology.
                {" "}
              </p>
            </div>
          </div>
          <div >
            <StackingCards />
            {/* <Test/> */}
          </div>

        </div>

        <div className="animated-video">
          {/* <img src="./assets/images/layer.png" alt="layer" />
          <Videoanimation /> */}
          {/* <CanvasAnimation1/> */}

        </div>
      </div>
    </div>
  );
};

export default Ecosystem;
